import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import { addMonths, startOfMonth } from "date-fns";
import { format } from "date-fns";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, bool, date, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type VehicleGoalFormType = {
  readonly name: string;
  readonly purchaseDate: Date;
  readonly expectedPrice: number;
  readonly monthlyContribution: number;
  readonly monthlyContributionWithFee: number;
  readonly interestRate: number;
  readonly inflationRate: number;
  readonly feeRate: number;
  readonly referenceStartDate: Date;
  readonly includeInflation?: boolean;
  readonly includeFee?: boolean;
  readonly note?: string;
  readonly priority?: boolean;
};

export const minDate = startOfMonth(addMonths(new Date(), 1));

export const getVehicleGoalFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<VehicleGoalFormType> = (t) => {
  return object({
    name: string().required(t(Resources.Validation.Required)),
    purchaseDate: date()
      .required(t(Resources.Validation.Required))
      .min(minDate, t(Resources.Validation.MustBeOlderThanDate, { date: format(minDate, "dd.MM.yyyy") })),
    referenceStartDate: date().required(t(Resources.Validation.Required)),
    expectedPrice: number()
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .min(1, t(Resources.Validation.Number.MoreThen, { count: 0 }))
      .required(t(Resources.Validation.Required)),
    monthlyContribution: number().required(t(Resources.Validation.Required)),
    monthlyContributionWithFee: number().required(t(Resources.Validation.Required)),
    interestRate: number().required(t(Resources.Validation.Required)),
    inflationRate: number().required(t(Resources.Validation.Required)),
    feeRate: number().required(t(Resources.Validation.Required)),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
    priority: bool(),
    includeInflation: bool(),
    includeFee: bool(),
  }).defined();
};
